import axiosInstance from '../helpers/axiosConfig';

class NewsLetterService {
  static subscribe = (body) => axiosInstance.post(`/news-letter`, body);
}

export default NewsLetterService;
